import apiClient from "../utils/apiUtils";

export const employeeService = {
  // ==================== EMPLOYEE CRUD APIs ====================

  // Get all employees with pagination and filters
  getEmployees: async (params = {}) => {
    const response = await apiClient.get("/v1/employment-details", { params });
    return response.data;
  },

  // Get single employee by ID
  getEmployee: async (id) => {
    const response = await apiClient.get(`/v1/employment-details/${id}`);
    return response.data;
  },

  // Create new employee
  createEmployee: async (payload) => {
    const response = await apiClient.post("/v1/employment-details", payload);
    return response.data;
  },

  // Update existing employee
  updateEmployee: async (id, payload) => {
    const response = await apiClient.put(
      `/v1/employment-details/${id}`,
      payload,
    );
    return response.data;
  },

  // Delete employee
  deleteEmployee: async (id) => {
    const response = await apiClient.delete(`/v1/employment-details/${id}`);
    return response.data;
  },

  // Search employees
  searchEmployees: async (query, params = {}) => {
    const response = await apiClient.get("/v1/employment-details/search", {
      params: { ...params, search: query },
    });
    return response.data;
  },
};

export default employeeService;
